var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.06 74.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#3f8ad1;}.cls-4{fill:#3475ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.06,
    y: 0.26,
    width: 74,
    height: 74
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1336",
    "data-name": "Ellisse 1336"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.88,
    cy: 36.88,
    r: 35.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.88,73.76A36.88,36.88,0,1,1,73.76,36.88,36.92,36.92,0,0,1,36.88,73.76Zm0-71.05A34.17,34.17,0,1,0,71.05,36.88,34.21,34.21,0,0,0,36.88,2.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.54,51.65h-19V22.11h19ZM55.81,23.84H40.31V49.92h15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.18,51.65h-19V22.11h19ZM33.44,23.84H18V49.92H33.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.62,
    y: 20.84,
    width: 6.83,
    height: 31.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.01,
    y: 20.84,
    width: 6.76,
    height: 31.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.47,
    y: 17.03,
    width: 25.48,
    height: 39.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49,56.73H23.47V17H49ZM46.62,19.36H25.8v35H46.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.81e6062a0d3bf3896284cb1a2e9273fd.svg";
export { ForwardRef as ReactComponent };